import { Route } from '@angular/router';
import { ApiErrorComponent } from '@/shared/components/api-error/api-error.component';
import { AuthDeflectionComponent } from '@/shared/components/auth-deflection/auth-deflection.component';

const routes: Array<Route> = [
  {
    path: '',
    redirectTo: 'status',
    pathMatch: 'full',
  },
  {
    path: 'status',
    loadChildren: () => import('@/status'),
  },
  {
    path: 'auth-deflection',
    component: AuthDeflectionComponent,
  },
  {
    path: 'service-status',
    redirectTo: 'status',
    pathMatch: 'full',
  },
  {
    path: 'tv-error-codes',
    loadChildren: () => import('@/tv-error-codes/tv-error-codes.module').then((m) => m.TVErrorCodesModule),
  },
  {
    path: '~api',
    children: [
      {
        path: 'pingfed-login',
        loadComponent: () =>
          import('@/api/pingfed-login-redirect/pingfed-login-redirect.component').then(
            (c) => c.PingfedLoginRedirectComponent
          ),
      },
      {
        path: 'place-pod-order',
        loadComponent: () =>
          import('@/api/place-pod-order/place-pod-order.component').then((c) => c.PlacePodOrderComponent),
      },
      {
        path: 'place-hub-order',
        loadComponent: () =>
          import('@/api/place-hub-order/place-hub-order.component').then((c) => c.PlaceHubOrderComponent),
      },
      {
        path: 'place-pod-health-order',
        loadComponent: () =>
          import('@/api/place-pod-health-order/place-pod-health-order.component').then((c) => c.PlacePodHealthOrderComponent),
      },
    ],
  },
  {
    path: 'api-error',
    component: ApiErrorComponent,
  },
  {
    path: '404',
    redirectTo: 'status',
    pathMatch: 'full',
    // path: '404',
    // loadComponent: () => import('@/shared/components/api-error/api-error.component').then((mod) => mod.ApiErrorComponent),
  },
];

export const appRoutes: Route[] = [...routes];
